import React from "react";
import ColorRelationshipTab, {
  ColorRelationshipConfig,
} from "./ColorRelationshipTab";

const config: ColorRelationshipConfig = {
  relationshipType: "Adjacency",
  labels: {
    addTitle: "Mark Some Colors as Adjacent",
    addButton: "Mark as Adjacent",
    existingTitle: "Existing Adjacencies",
    addSuccess: "Adjacencies added successfully.",
    addError: "Failed to add adjacencies.",
    deleteConfirm: (c1, c2) => `Remove adjacency between "${c1}" and "${c2}"?`,
    deleteAction: "Remove adjacency",
    deleteSuccess: "Adjacency removed.",
  },
};

const AdjacenciesTab: React.FC = () => <ColorRelationshipTab config={config} />;

export default AdjacenciesTab;
